// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/workflow/approval-workflow/approval-workflow.scss
// module id = 852
// module chunks = 50